( function () {
	'use strict';

	function layoutFactory ( $window ) {
		function checkPlatform () {
			var platformChecker = $window.navigator.platform;

			return platformChecker === 'iPad' || platformChecker === 'Android' || platformChecker === 'iPhone';
		}

		return {
			'checkPlatform' : checkPlatform
		};
	}

	angular
		.module( 'app.layout' )
		.factory( 'layoutFactory', layoutFactory  );

	layoutFactory.$inject = [ '$window' ];
} )( );
